import React, { useState } from 'react';
import CustomModal from '../../../../custom/modal/customModal';
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { UnitApi } from '../../../../App/api/setting';
import { toast } from 'react-toastify';

function UnitMeasurementModal({ isOpen, onClose, data, fetchAllData }) {


    // const formik = useFormik({
    //     initialValues: {
    //         name: "",
    //         unitType: "",
    //         unit: "",      
    //     },
    //     validationSchema: Yup.object({
    //         name: Yup.string()
    //             .max(50, "Must be 50 characters or less")
    //             .required("Name is required"),
    //         unitType: Yup.string().required("Unit type is required"),
    //         unit: Yup.string().required("Unit is required")
    //     }),
    //     onSubmit: async (values) => {
    //         // const payload = {
    //         //     ...values,
    //         // };
    //         // // Log the form data to console
    //         // console.log("Form data:", values);

    //         handleClose();
    //     },
    // });
    const formik = useFormik({
        initialValues: {
            name: data?.name || "",
            unit: data?.unit || ""
        },
        onSubmit: async(values) => {
            try {
            if (data?._id) {
                await UnitApi.master.updateUnitMaster(data?._id,values); 
                fetchAllData();
                toast.success("Unit Master Updated Successfully")
                handleClose();
            } else {
                await UnitApi.master.createUnitMaster(values); 
                fetchAllData();
                toast.success("Unit Master Created Successfully")
                handleClose();
            }
        }catch (err) {
            toast.error(`Error: ${err.message || "Something went wrong"}`);
        }
    },
        validate: (values) => {
            const errors = {};
            if (!values.name) errors.name = "Unit Name is required";
            if (!values.unit) errors.unit = "Unit Value is required";
            return errors;
        },
    });
    
    const handleClose = () => {
        formik.resetForm(); 
        onClose();
    };

    
    
    return (
      
        <CustomModal isOpen={isOpen} onClose={handleClose} title="Add Unit Details">
    <form onSubmit={formik.handleSubmit} className="mt-4">
        {/* Unit Name Input */}
        <div className="mb-4">
            <label className="block text-gray-700 text-lg">
                Enter Unit Name
            </label>
            <input
                value={formik.values.name}
                onChange={(e) => formik.setFieldValue("name", e.target.value)}
                className="mt-1 block h-10 p-2 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                placeholder="Enter unit name (e.g., Height, Weight)"
            />
            {formik.touched.name && formik.errors.name && (
                <p className="text-red-500 text-sm mt-1">
                    {formik.errors.name}
                </p>
            )}
        </div>

        {/* Unit Value Input */}
        <div className="mb-4">
            <label className="block text-gray-700 text-lg">
                Enter Unit Value <span className='text-sm'>(e.g., mm, kg)</span>
            </label>
            <input
                value={formik.values.unit}
                onChange={(e) => formik.setFieldValue("unit", e.target.value)}
                className="mt-1 block w-full h-10 p-2 border rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                placeholder="Enter unit value (e.g., mm, kg)"
            />
            {formik.touched.unit && formik.errors.unit && (
                <p className="text-red-500 text-sm mt-1">
                    {formik.errors.unit}
                </p>
            )}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-3">
            <button
                type="button"
                onClick={handleClose}
                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
                Cancel
            </button>
            <button
                type="submit"
                className="bg-[--color--2] text-white px-4 py-2 rounded hover:bg-[--color--1]"
            >
                {data?._id ?"Update":"Save"}
            </button>
        </div>
    </form>
</CustomModal>

    );
}

export default UnitMeasurementModal;
